import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportcab() {



  const cardData = {
"keyword": "Pune to Mumbai Airport Cab",

"headingDescription":
  "Shivai Travels offers reliable Pune to Mumbai Airport Cab service for smooth, safe, and timely transfers to Chhatrapati Shivaji Maharaj International Airport. Whether you are traveling for domestic or international flights, business trips, or family travel, our airport taxi service ensures punctual pickups, comfortable rides, and stress-free journeys. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we guarantee a hassle-free travel experience. Our fleet includes sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With 24/7 availability, easy booking, and door-to-door pickup and drop service, Shivai Travels provides a dependable and comfortable airport transfer solution from Pune to Mumbai Airport.",

"topPlaces": [
  {
    "title": "Chhatrapati Shivaji Maharaj International Airport",
    "description":
      "Chhatrapati Shivaji Maharaj International Airport is the main international airport in Mumbai handling domestic and international flights. Pune to Mumbai Airport Cab service ensures timely and comfortable transfers for flight passengers."
  },
  {
    "title": "Terminal 1 (Domestic Terminal)",
    "description":
      "Terminal 1 handles domestic flight operations at Mumbai Airport. Travelers from Pune use cab services for convenient and punctual drop-offs for domestic travel."
  },
  {
    "title": "Terminal 2 (International Terminal)",
    "description":
      "Terminal 2 is the international terminal of Mumbai Airport known for its modern infrastructure and global connectivity. Pune airport cab service ensures smooth transfers for international travelers."
  },
  {
    "title": "Bandra Kurla Complex (BKC)",
    "description":
      "Bandra Kurla Complex is a major business district in Mumbai located close to the airport. Many corporate travelers use Pune to Mumbai airport cabs for meetings and business visits here."
  },
  {
    "title": "Andheri East",
    "description":
      "Andheri East is a key commercial and residential hub near Mumbai Airport. Airport cab services from Pune provide easy access to hotels, offices, and transit points in this area."
  },
  {
    "title": "Vile Parle",
    "description":
      "Vile Parle is one of the closest residential areas to Mumbai Airport. Travelers often use Pune to Mumbai airport cab service for quick and convenient access to flights."
  },
  {
    "title": "Bandra West",
    "description":
      "Bandra West is a premium locality known for shopping streets, restaurants, and nightlife. Airport cab services from Pune provide comfortable travel for tourists and business visitors."
  },
  {
    "title": "Powai",
    "description":
      "Powai is a modern residential and IT hub in Mumbai. Pune to Mumbai Airport Cab service ensures smooth connectivity for professionals and families traveling to and from the airport."
  },
  {
    "title": "Santacruz",
    "description":
      "Santacruz is a well-connected area near Mumbai Airport with hotels and residential zones. Airport taxi service from Pune offers convenient transfers for all types of travelers."
  },
  {
    "title": "Juhu",
    "description":
      "Juhu is a popular beachside locality known for tourism and luxury residences. Pune airport cab service provides easy access between Juhu and Mumbai Airport for travelers."
  }
],



services: [
  {
    name: "Pune to Mumbai Airport Cab",
    description: "Pune to Mumbai airport cab service provides reliable transportation between Pune and Mumbai Airport terminals with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and safe airport journeys for business travelers, tourists, and families. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for airport transportation needs. Flexible booking options allow convenient one-way and round-trip airport cab reservations."
  },
  {
    name: "Pune to Mumbai Airport Taxi",
    description: "Pune to Mumbai airport taxi service offers dependable airport transportation from Pune to Mumbai domestic and international terminals. Comfortable vehicles provide spacious seating and luggage capacity suitable for long-distance airport travel. Professional drivers ensure punctual pickup and safe driving services via the Mumbai–Pune Expressway. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Pune. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Cab from Pune to Mumbai Airport",
    description: "Cab from Pune to Mumbai airport service provides smooth and reliable transportation for passengers traveling to Mumbai Airport from Pune. Vehicles ensure comfortable expressway travel suitable for airport transfers, business travel, tourism, and family journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow easy airport cab reservations."
  },
  {
    name: "Taxi Pune to Mumbai Airport",
    description: "Taxi Pune to Mumbai airport service offers comfortable transportation between Pune and Mumbai Airport terminals with professional drivers and well-maintained vehicles. Vehicles provide smooth highway travel with sufficient luggage space suitable for airport passengers. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Pune. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Pune to Airport Cab Booking",
    description: "Pune to airport cab booking service allows passengers to reserve reliable airport transportation from Pune to Mumbai Airport terminals. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for airport travel requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow instant and advance airport cab reservations."
  },
  {
    name: "Pune to Mumbai Airport Fare",
    description: "Pune to Mumbai airport fare service provides transparent pricing information for passengers planning airport travel between Pune and Mumbai. Travelers can estimate transportation costs based on vehicle type, travel distance, and airport terminal requirements. Comfortable vehicles ensure smooth expressway travel with professional drivers providing safe transportation services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient fare estimation and airport cab reservations."
  },
  {
    name: "One Way Cab Pune to Airport",
    description: "One way cab Pune to airport service provides economical transportation for passengers traveling from Pune to Mumbai Airport without return travel requirements. Comfortable vehicles ensure smooth expressway travel suitable for business travelers, tourists, and family airport transfers. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Pune. Flexible booking options allow convenient one-way airport cab reservations."
  },
  {
    name: "Round Trip Taxi Pune to Airport",
    description: "Round trip taxi Pune to airport service offers convenient return transportation between Pune and Mumbai Airport terminals. Comfortable vehicles provide smooth highway travel with experienced drivers ensuring safe and reliable airport transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Ideal for business travel, family airport transfers, and tourism journeys. Flexible booking options allow convenient round-trip airport taxi reservations."
  },
  {
    name: "Cheap Pune to Mumbai Airport Cab",
    description: "Cheap Pune to Mumbai airport cab service provides affordable airport transportation between Pune and Mumbai with comfortable vehicles and economical pricing. Vehicles ensure reliable expressway travel suitable for airport transfers, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost airport cab reservations."
  },
  {
    name: "Luxury Airport Cab Pune to Mumbai",
    description: "Luxury airport cab Pune to Mumbai service provides premium airport transportation with high-end vehicles and professional chauffeurs. Luxury vehicles offer spacious interiors, smooth ride quality, and comfortable travel suitable for executives, VIP guests, and family airport transfers. Professional drivers ensure safe driving and punctual pickup services via the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury airport cab reservations."
  },
  {
    name: "Best Airport Taxi Pune Mumbai",
    description: "Best airport taxi Pune Mumbai service offers dependable airport transportation with comfortable vehicles and experienced chauffeurs for smooth travel between Pune and Mumbai Airport terminals. Vehicles provide spacious seating and luggage capacity suitable for domestic and international travelers. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Mumbai. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Sedan Cab Pune to Airport",
    description: "Sedan cab Pune to airport service offers economical and comfortable transportation for solo travelers, couples, and small families traveling to Mumbai Airport from Pune. Sedan vehicles provide smooth expressway travel with comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient sedan airport cab reservations."
  },
  {
    name: "SUV Taxi Pune to Airport",
    description: "SUV taxi Pune to airport service provides spacious transportation for families and groups traveling from Pune to Mumbai Airport terminals. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance airport journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient SUV airport taxi reservations."
  },
  {
    name: "24x7 Airport Cab Pune Mumbai",
    description: "24x7 airport cab Pune Mumbai service provides round-the-clock transportation between Pune and Mumbai Airport terminals for passengers traveling at any time. Comfortable vehicles ensure reliable expressway travel with professional drivers maintaining punctual pickup schedules and safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Mumbai. Ideal for early morning flights, late-night arrivals, and emergency airport travel needs. Flexible booking options allow convenient airport cab reservations anytime."
  },
  {
    name: "Direct Airport Transfer Pune",
    description: "Direct airport transfer Pune service provides non-stop transportation between Pune and Mumbai Airport with comfortable vehicles and experienced drivers. Vehicles ensure smooth highway travel suitable for business travelers, tourists, and family airport transfers. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Pune. Flexible booking options allow convenient direct airport transfer reservations."
  },
  {
    name: "Pune to T2 Mumbai Airport Cab",
    description: "Pune to T2 Mumbai airport cab service provides reliable transportation from Pune to Mumbai Terminal 2 with comfortable vehicles and professional chauffeurs. Vehicles offer spacious seating and luggage capacity suitable for domestic and international airport travelers. Professional drivers ensure punctual pickup and safe expressway travel throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient T2 airport cab reservations."
  }
],

tableData: [
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Airport Taxi"],
  ["Cab from Pune to Mumbai Airport", "Taxi Pune to Mumbai Airport"],
  ["Pune to Airport Cab Booking", "Pune to Mumbai Airport Fare"],
  ["One Way Cab Pune to Airport", "Round Trip Taxi Pune to Airport"],
  ["Cheap Pune to Mumbai Airport Cab", "Luxury Airport Cab Pune to Mumbai"],
  ["Best Airport Taxi Pune Mumbai", "Sedan Cab Pune to Airport"],
  ["SUV Taxi Pune to Airport", "24x7 Airport Cab Pune Mumbai"],
  ["Direct Airport Transfer Pune", "Pune to T2 Mumbai Airport Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mumbai Airport Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Mumbai Airport cab service with punctual pickup, professional drivers, and comfortable vehicles for smooth airport transportation."
      },
      {
        WhyChooseheading: "Affordable Airport Cab Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Mumbai Airport cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Mumbai Airport Cab Availability",
        WhyChoosedescription: "Our Pune to Mumbai Airport cab service operates 24 hours a day for early morning flights, late-night airport arrivals, business travel, and emergency airport transfers."
      },
      {
        WhyChooseheading: "Comfortable & Sanitized AC Airport Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance airport travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Airport Transfers",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Mumbai Airport drop, airport pickup service, round-trip airport transfers, and customized travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Airport Cab Vehicles",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Expressway & Airport Drivers",
        WhyChoosedescription: "Our experienced drivers are familiar with the Mumbai Pune Expressway and Mumbai Airport routes, ensuring safe driving, timely arrivals, and hassle-free airport transportation."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mumbai Airport cab service?", answer: "Pune to Mumbai Airport cab service provides taxi transportation between Pune and Mumbai Airport for domestic and international travelers." },
    { question: "Is Pune to Mumbai Airport cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 airport cab service from Pune to Mumbai Airport." },
    { question: "Which vehicles are available for Mumbai Airport travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way Pune to Mumbai Airport cab?", answer: "Yes, customers can book one-way as well as round-trip airport taxi services." },
    { question: "Do you provide airport pickup from Mumbai Airport?", answer: "Yes, Shivai Travels provides both airport pickup and airport drop services." },
    { question: "Are all airport taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable airport travel." },
    { question: "Can I book Pune to Mumbai Airport cab service online?", answer: "Yes, customers can easily book airport cab service online or through phone booking." },
    { question: "Do you provide airport taxis for family and group travel?", answer: "Yes, Shivai Travels provides comfortable airport taxi options for families and groups." },
    { question: "Are airport taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance airport cab booking available?", answer: "Yes, advance booking is available and recommended for flight schedules and airport transfers." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harshad Kulkarni",
    feedback:
      "Shivai Travels provided a very smooth Pune to Mumbai Airport cab service with timely pickup, comfortable seating, and a professional driver ensuring stress-free travel before my flight.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "The airport cab service from Pune to Mumbai was highly reliable with on-time arrival and a clean, well-maintained car, making my journey comfortable and worry-free.",
    rating: 5
  }
];








































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab",
  "image": "https://shivaitravels.com/assets/images/pune-to-mumbai-airport-cab.jpg",
  "description": "Book Pune to Mumbai airport cab service for safe and timely airport transfers. Shivai Travels offers affordable one-way and round-trip taxi service with sedan, SUV, Innova, and luxury cabs available 24x7 for direct airport pickup and drop.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹1499",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-mumbai-airport-cab"
  }
};








  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Airport Cab | Reliable Airport Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Mumbai airport cab for safe, affordable, and timely airport transfers. One-way and round-trip taxi service with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to mumbai airport cab, pune to mumbai airport taxi, cab from pune to mumbai airport, taxi pune to mumbai airport, pune to airport cab booking, pune to mumbai airport fare, one way cab pune to airport, round trip taxi pune to airport, cheap pune to mumbai airport cab, luxury airport cab pune to mumbai, best airport taxi pune mumbai, sedan cab pune to airport, suv taxi pune to airport, 24x7 airport cab pune mumbai, direct airport transfer pune, Pune to Mumbai Airport Cab Service, Pune to Mumbai Airport Taxi, Mumbai Airport Cab from Pune, Pune to Mumbai Airport Cab Booking, Pune to Airport Taxi Mumbai, One Way Pune to Mumbai Airport"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportcab;